import { render, staticRenderFns } from "./SelectAccessories.vue?vue&type=template&id=5a13084e&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./SelectAccessories.vue?vue&type=script&lang=js"
export * from "./SelectAccessories.vue?vue&type=script&lang=js"
import style0 from "./SelectAccessories.vue?vue&type=style&index=0&id=5a13084e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports